<template>
  <div>
    <div v-if="isColumnSelectorEnabled" class="datatable-toolbar">
      <div class="page-size-box">
        <label class="toolbar-label">{{ itemsPerPageLabel || "Hiển thị" }}</label>
        <select class="form-control form-control-sm datatable-page-size" :value="pagination.pageSize"
                @change="changeItemPerPage(Number($event.target.value))">
          <option v-for="(number, idx) in itemsPerPageValues" :key="'page-size-' + idx" :value="number">
            {{ number }}
          </option>
        </select>
      </div>

      <div class="column-selector">
        <button type="button" class="btn btn-sm column-selector-toggle"
                @click.stop="toggleColumnMenu">
          Cột hiển thị
          <span class="selected-count">{{ selectedSelectableCount }}</span>
        </button>
        <div v-if="showColumnMenu" class="column-selector-menu" @click.stop>
          <div class="column-selector-head">
            <div class="column-selector-title">Tùy chỉnh cột hiển thị</div>
            <div class="column-selector-subtitle">
              {{ selectedSelectableCount }}/{{ selectableColumns.length }} cột đang bật
            </div>
          </div>
          <div class="column-selector-list">
            <label v-for="col in selectableColumns" :key="'col-toggle-' + col.key" class="column-selector-item">
              <input type="checkbox" :checked="isColumnVisible(col.key)"
                     @change="onColumnToggle(col.key, $event.target.checked)">
              <span>{{ col.label }}</span>
            </label>
          </div>
          <div class="column-selector-actions">
            <button type="button" class="btn btn-light btn-sm column-selector-action-btn column-selector-action-btn-light"
                    @click="resetDefaultColumns">Mặc định</button>
            <button type="button" class="btn btn-primary btn-sm column-selector-action-btn" @click="selectAllColumns">Chọn tất cả</button>
          </div>
        </div>
      </div>
    </div>

    <CDataTable
      v-bind="options"
      :items="items"
      :loading="loading"
      :show-empty="true"
      :bordered="true"
      :fields="visibleFields"
      :sorter="options.sorter"
      :clickableRows="options.clickableRows"
      :columnFilter="options.columnFilter"
      :tableFilter="options.tableFilter"
      :hover="options.hover"
      :itemsPerPageSelect="isColumnSelectorEnabled ? false : options.itemsPerPageSelect"
      :itemsPerPage="pagination.pageSize"
      @pagination-change="changeItemPerPage"
      @row-clicked="rowClick"
      @update:table-filter-value="filterTable"
    >
      <template slot="thead-top" v-if="options.isSelectedAll">
        <div class="group-checkbox" style="position: absolute; left:12px;top: 8px">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" v-model="options.selectedAll"
                   @change="changeSelectAll()" id="selectedAll"/>
            <label class="custom-control-label" for="selectedAll"></label>
          </div>
        </div>
      </template>
      <template
        :slot="slot"
        slot-scope="data, item"
        v-for="slot in options.slots"
      >
        <slot
          :name="slot"
          :value="data.value"
          :index="data.index"
          :item="data.item"
        ></slot>
      </template>
      <template slot="no-items-view">
        <span style="color:#969696;">Danh sách trống!</span>
      </template>
      <template slot="loading">
        <BaseLoading :loading="loading"/>
      </template>
    </CDataTable>
    <div v-if="pagination && pagination.totalElement !== 0">
      <div class="base-datatable-footer">
        <div class="base-datatable-meta">
          {{ fromElement }}-{{ toElement }} /
          {{ this.pagination.totalElement }} bản ghi
        </div>
        <nav class="base-datatable-pagination">
          <CPagination
            @update:activePage="updateActivePage"
            :activePage.sync="pagination.activePage"
            :pages="pagination.pages"
            :total-rows="pagination.totalRows"
            :per-page="pagination.pageSize"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </div>
    </div>
  </div>
</template>
<script>
import BaseLoading from "./BaseFormLoading";

const COLUMN_PREFS_STORAGE_KEY = "ttcs-table-column-preferences";

export default {
  components: {BaseLoading},
  props: ["options", "dataSource"],
  inheritAttrs: false,
  data() {
    var that = this;
    return {
      loading: false,
      items: [],
      pagination: {
        activePage: 1,
        pages: 1,
        pageSize: 20,
        totalElement: 1
      },
      visibleColumnKeys: [],
      showColumnMenu: false
    };
  },
  methods: {
    buildDefaultColumnSelectorId() {
      const routePath = this.$route && this.$route.path ? this.$route.path : "unknown-route";
      const dsUrl = this.dataSource && this.dataSource.url ? this.dataSource.url : "unknown-datasource";
      return `${routePath}::${dsUrl}`.replace(/\s+/g, "").toLowerCase();
    },
    setupColumnSelectorConfig() {
      if (!this.options) return;

      const fields = Array.isArray(this.options.fields) ? this.options.fields : [];
      const normalizedFields = fields.map((field) => {
        const fieldObj = typeof field === "string" ? { key: field } : { ...field };
        if (["checkbox", "action"].includes(fieldObj.key) && fieldObj.columnTogglable === undefined) {
          fieldObj.columnTogglable = false;
        }
        return fieldObj;
      });

      if (normalizedFields.length) {
        this.$set(this.options, "fields", normalizedFields);
      }

      const existingSelector = this.options.columnSelector || {};
      const defaultId = this.buildDefaultColumnSelectorId();
      const mergedSelector = {
        enabled: existingSelector.enabled !== false,
        id: existingSelector.id || existingSelector.storageKey || defaultId,
        storageKey: existingSelector.storageKey || existingSelector.id || defaultId,
        defaultColumns:
          Array.isArray(existingSelector.defaultColumns) && existingSelector.defaultColumns.length
            ? existingSelector.defaultColumns
            : normalizedFields.map((field) => field.key),
      };
      this.$set(this.options, "columnSelector", mergedSelector);
    },
    setupPagination(_dataResponse) {
      this.pagination.pages = Math.ceil(
        _dataResponse.totalElement / this.pagination.pageSize
      );
      this.pagination.totalElement = _dataResponse.totalElement;
    },
    updateActivePage: function (activePage) {
      this.pagination.activePage = activePage;
      this.loadData(true);
    },
    loadData(isNavPaging, isLoading) {
      if (isLoading !== undefined && isLoading === false) {
        this.loading = false;
      } else {
        this.loading = true;

      }

      var that = this;
      var _dataSource = Object.assign({}, this.dataSource);
      var _dataSubmit = _dataSource.dataSubmit ? _dataSource.dataSubmit() : {};

      if (_dataSource.dataRef) {
        _dataSubmit = this.$helper.setupDataSubmit(_dataSource.dataRef);
      }
      if (!isNavPaging && this.pagination) {
        this.pagination.activePage = 1;
      }
      if (this.pagination) {
        _dataSubmit.pageNumber = this.pagination.activePage - 1;
        _dataSubmit.pageSize = this.pagination.pageSize;
      }
      _dataSource.dataSubmit = function () {
        return _dataSubmit;
      };
      if (_dataSource.isAsync) {
        _dataSource.successCallback = async function (response) {
          let dataResponse = response.data;
          if (that.$helper.validResponse(that.$router, dataResponse)) {
            let _dataResponse = await _dataSource.response(dataResponse);
            that.items = that.pagination
              ? _dataResponse.list
                ? _dataResponse.list.content
                : _dataResponse.dataContent.content
              : _dataResponse[_dataSource.resultListAttrName];
            if (that.pagination) {
              that.setupPagination(_dataResponse);
            }
          }
          if (that.items) {
            for (var i = 0; i < that.items.length; i++) {
              Object.keys(that.items[i]).forEach(function (k) {
                that.items[i][k] = that.items[i][k] == null ? '' : that.items[i][k];
              });
            }
          }
          that.loading = false;
        };
        _dataSource.errorCallback = function (error) {
          that.loading = false;
          that.$helper.handleError(that.$router, error);
        };
      } else {
        _dataSource.successCallback = function (response) {
          let dataResponse = response.data;
          if (that.$helper.validResponse(that.$router, dataResponse)) {
            let _dataResponse = _dataSource.response(dataResponse);
            that.items = that.pagination
              ? _dataResponse.list
                ? _dataResponse.list.content
                : _dataResponse.dataContent.content
              : _dataResponse[_dataSource.resultListAttrName];
            if (that.pagination) {
              that.setupPagination(_dataResponse);
            }
            if (that.items) {
              for (var i = 0; i < that.items.length; i++) {
                Object.keys(that.items[i]).forEach(function (k) {
                  that.items[i][k] = that.items[i][k] == null ? '' : that.items[i][k];
                });
              }
            }
          }
          that.loading = false;
        };
        _dataSource.errorCallback = function (error) {
          that.loading = false;
          that.$helper.handleError(that.$router, error);
        };
      }
      this.$helper.loadDataSource(_dataSource);
    },
    changeItemPerPage(value) {
      this.pagination.activePage = 1;
      this.pagination.pageSize = value;
      this.loadData();
    },
    changeSelectAll() {
      this.$emit("change-selectedAll", this.options.selectedAll);
    },
    rowClick(_item, _index, _column, _event) {
      this.$emit("row-click", {
        item: _item, index: _index, column: _column, event: _event
      });
    },
    filterTable(event) {

    },
    getStorageKey() {
      const columnSelector = this.options && this.options.columnSelector ? this.options.columnSelector : {};
      return columnSelector.storageKey || null;
    },
    getColumnSelectorId() {
      const columnSelector = this.options && this.options.columnSelector ? this.options.columnSelector : {};
      return columnSelector.id || columnSelector.storageKey || null;
    },
    getStoragePrefsMap() {
      if (typeof localStorage === "undefined") return {};
      try {
        const raw = localStorage.getItem(COLUMN_PREFS_STORAGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? parsed : {};
      } catch (e) {
        return {};
      }
    },
    saveStoragePrefsMap(mapData) {
      if (typeof localStorage === "undefined") return;
      try {
        localStorage.setItem(COLUMN_PREFS_STORAGE_KEY, JSON.stringify(mapData || {}));
      } catch (e) {
        // ignore localStorage write errors
      }
    },
    getDefaultVisibleColumnKeys() {
      const fields = this.normalizedFields;
      if (!fields.length) return [];
      const selector = this.options && this.options.columnSelector ? this.options.columnSelector : {};
      const defaults = Array.isArray(selector.defaultColumns) && selector.defaultColumns.length
        ? selector.defaultColumns.map(String)
        : fields.map(field => String(field.key));
      const validKeys = fields.map(field => String(field.key));
      const forcedKeys = fields
        .filter(field => field.columnTogglable === false)
        .map(field => String(field.key));
      const filtered = defaults.filter(key => validKeys.includes(key));
      const combined = Array.from(new Set([...forcedKeys, ...filtered]));
      return combined.length ? combined : validKeys;
    },
    initializeVisibleColumns() {
      if (!this.isColumnSelectorEnabled) return;
      const validKeys = this.normalizedFields.map(field => String(field.key));
      const forcedKeys = this.normalizedFields
        .filter(field => field.columnTogglable === false)
        .map(field => String(field.key));
      if (!validKeys.length) {
        this.visibleColumnKeys = [];
        return;
      }

      const storageKey = this.getStorageKey();
      const selectorId = this.getColumnSelectorId();
      let initialized = false;
      if (selectorId && typeof localStorage !== "undefined") {
        try {
          const prefsMap = this.getStoragePrefsMap();
          const parsed = prefsMap[selectorId];
          if (Array.isArray(parsed)) {
            const restored = parsed.map(String).filter(key => validKeys.includes(key));
            if (restored.length) {
              this.visibleColumnKeys = Array.from(new Set([...forcedKeys, ...restored]));
              initialized = true;
            }
          }
        } catch (e) {
          // ignore corrupted localStorage values
        }
      }

      // Backward compatibility: migrate old per-key storage to shared map.
      if (!initialized && storageKey && typeof localStorage !== "undefined") {
        try {
          const rawLegacy = localStorage.getItem(storageKey);
          if (rawLegacy) {
            const parsedLegacy = JSON.parse(rawLegacy);
            if (Array.isArray(parsedLegacy)) {
              const restoredLegacy = parsedLegacy.map(String).filter(key => validKeys.includes(key));
              if (restoredLegacy.length) {
                this.visibleColumnKeys = Array.from(new Set([...forcedKeys, ...restoredLegacy]));
                initialized = true;
                this.persistVisibleColumns();
                localStorage.removeItem(storageKey);
              }
            }
          }
        } catch (e) {
          // ignore legacy parse errors
        }
      }

      if (!initialized) {
        this.visibleColumnKeys = this.getDefaultVisibleColumnKeys();
      }
    },
    persistVisibleColumns() {
      const selectorId = this.getColumnSelectorId();
      if (!selectorId || typeof localStorage === "undefined") return;
      try {
        const prefsMap = this.getStoragePrefsMap();
        prefsMap[selectorId] = this.visibleColumnKeys;
        this.saveStoragePrefsMap(prefsMap);
      } catch (e) {
        // ignore localStorage write errors
      }
    },
    toggleColumnMenu() {
      this.showColumnMenu = !this.showColumnMenu;
    },
    isColumnVisible(key) {
      return this.visibleColumnKeys.includes(String(key));
    },
    onColumnToggle(key, checked) {
      const colKey = String(key);
      if (checked) {
        if (!this.visibleColumnKeys.includes(colKey)) {
          this.visibleColumnKeys = [...this.visibleColumnKeys, colKey];
        }
      } else {
        if (this.visibleColumnKeys.length <= 1) {
          return;
        }
        this.visibleColumnKeys = this.visibleColumnKeys.filter(each => each !== colKey);
      }
      this.persistVisibleColumns();
    },
    selectAllColumns() {
      this.visibleColumnKeys = this.selectableColumns.map(col => String(col.key));
      this.persistVisibleColumns();
    },
    resetDefaultColumns() {
      this.visibleColumnKeys = this.getDefaultVisibleColumnKeys();
      this.persistVisibleColumns();
    },
    onDocumentClick() {
      this.showColumnMenu = false;
    },
  },
  created() {
    this.setupColumnSelectorConfig();
    this.pagination = this.options.noPaging ? false : this.pagination;
    if (this.pagination && this.options.pageSize) {
      this.pagination.pageSize = this.options.pageSize;
    }
  },
  mounted() {
    if (!(this.options && this.options.lazyLoad === false)) {
      this.loadData();
    }
    this.initializeVisibleColumns();
    document.addEventListener("click", this.onDocumentClick);
  },
  updated() {
  },
  computed: {
    isColumnSelectorEnabled() {
      if (!this.options || !this.options.itemsPerPageSelect) return false;
      if (!this.options.columnSelector) return true;
      return this.options.columnSelector.enabled !== false;
    },
    normalizedFields() {
      const fields = this.options && Array.isArray(this.options.fields) ? this.options.fields : [];
      return fields.map(field => {
        if (typeof field === "string") {
          const key = String(field);
          const autoForced = ["checkbox", "action"].includes(key);
          return { key, label: key, columnTogglable: !autoForced };
        }
        const autoForced = ["checkbox", "action"].includes(String(field.key));
        return {
          ...field,
          key: field.key,
          label: field.label || field.key,
          columnTogglable: field.columnTogglable !== undefined ? field.columnTogglable !== false : !autoForced
        };
      }).filter(field => field.key);
    },
    visibleFields() {
      if (!this.isColumnSelectorEnabled) {
        return this.options.fields;
      }
      const forcedKeys = this.normalizedFields
        .filter(field => field.columnTogglable === false)
        .map(field => String(field.key));
      const visibleSet = new Set(this.visibleColumnKeys.map(String));
      return this.normalizedFields.filter(field => {
        const key = String(field.key);
        return forcedKeys.includes(key) || visibleSet.has(key);
      });
    },
    selectableColumns() {
      return this.normalizedFields.filter(field => field.columnTogglable !== false);
    },
    selectedSelectableCount() {
      const selectableSet = new Set(this.selectableColumns.map(col => String(col.key)));
      return this.visibleColumnKeys.filter(key => selectableSet.has(String(key))).length;
    },
    itemsPerPageValues() {
      const select = this.options && this.options.itemsPerPageSelect ? this.options.itemsPerPageSelect : {};
      return Array.isArray(select.values) && select.values.length ? select.values : [10, 15, 20, 50];
    },
    itemsPerPageLabel() {
      const select = this.options && this.options.itemsPerPageSelect ? this.options.itemsPerPageSelect : {};
      return select.label !== undefined ? select.label : "";
    },
    getTotalElementByPage: function () {
      if (!this.pagination) {
        return 1;
      }
      return (this.pagination.activePage - 1) * this.pagination.pageSize + 1;
    },
    fromElement: function () {
      return (this.pagination.activePage - 1) * this.pagination.pageSize + 1;
    },
    toElement: function () {
      return (
        (this.pagination.activePage - 1) * this.pagination.pageSize +
        this.items.length
      );
    },
  },
  watch: {
    normalizedFields: {
      immediate: true,
      handler() {
        this.initializeVisibleColumns();
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onDocumentClick);
  }
};
</script>
<style scoped>
.datatable-toolbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: -30px;
  transform: translateY(14px);
  position: relative;
  z-index: 6;
}

.page-size-box {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
}

.toolbar-label {
  margin: 0;
  color: #3f5876;
  font-size: 13px;
  font-weight: 700;
}

.datatable-page-size {
  width: 84px;
  height: 34px;
  border-radius: 0.5rem;
  border: 1px solid #cfd9ea;
  background-color: #f6f9ff;
  background-image: linear-gradient(180deg, #f9fbff 0%, #edf3ff 100%);
  background-image:
    linear-gradient(180deg, #f9fbff 0%, #edf3ff 100%),
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23546e8a' d='M1.18.88a.75.75 0 0 1 1.06 0L5 3.65 7.76.88a.75.75 0 1 1 1.06 1.06L5.53 5.23a.75.75 0 0 1-1.06 0L1.18 1.94a.75.75 0 0 1 0-1.06Z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 0 26px 0 10px;
  background-position: right 8px center;
  background-size: 10px;
  color: #2f4f72;
  font-weight: 700;
  font-size: 13px;
  box-shadow: none;
}

.datatable-page-size:focus {
  outline: none;
  border-color: #2f8ae5;
  box-shadow: 0 0 0 2px rgba(47, 138, 229, 0.14);
}

.datatable-page-size option {
  background: #ffffff;
  color: #2f4f72;
}

.column-selector {
  position: relative;
}

.column-selector-toggle {
  height: 34px;
  min-width: 116px;
  border-radius: 0.6rem;
  border: 1px solid #1d5fae;
  background: linear-gradient(180deg, #2b82e2 0%, #1f6fd6 100%);
  color: #ffffff;
  font-weight: 600;
  font-size: 13px;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.35rem;
  padding: 0 0.4rem 0 0.55rem;
}

.selected-count {
  min-width: 20px;
  height: 20px;
  border-radius: 999px;
  background: #ffffff;
  color: #1e69c8;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.column-selector-toggle:hover {
  border-color: #184f94;
  color: #ffffff;
  background: linear-gradient(180deg, #2477d2 0%, #185fb7 100%);
}

.column-selector-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 10px);
  z-index: 30;
  min-width: 320px;
  max-width: 360px;
  border: 1px solid #dde3ec;
  border-radius: 0.85rem;
  background: #fff;
  box-shadow: 0 16px 28px rgba(44, 56, 74, 0.18);
  overflow: hidden;
}

.column-selector-head {
  padding: 0.75rem 0.85rem 0.55rem;
  border-bottom: 1px solid #edf1f6;
  background: #f8fbff;
}

.column-selector-title {
  font-size: 14px;
  font-weight: 700;
  color: #26384d;
}

.column-selector-subtitle {
  font-size: 12px;
  color: #6d7f95;
  margin-top: 0.2rem;
}

.column-selector-list {
  max-height: 280px;
  overflow: auto;
  padding: 0.45rem 0.5rem;
}

.column-selector-item {
  display: flex;
  align-items: center;
  font-size: 15px;
  margin-bottom: 0.2rem;
  padding: 0.42rem 0.5rem;
  border-radius: 0.45rem;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.column-selector-item:hover {
  background: #f6f9fc;
}

.column-selector-item:last-child {
  margin-bottom: 0;
}

.column-selector-item input {
  margin-right: 0.58rem;
  width: 16px;
  height: 16px;
  accent-color: #2f8ae5;
}

.column-selector-item span {
  color: #34495e;
  line-height: 1.2;
}

.column-selector-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  border-top: 1px solid #edf1f6;
  padding: 0.6rem 0.75rem;
  background: #fafcff;
}

.column-selector-action-btn {
  width: 96px;
  min-width: 96px;
  height: 40px !important;
  padding: 0 !important;
  line-height: 36px !important;
  border-radius: 0.6rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(31, 101, 184, 0.16);
}

.column-selector-action-btn-light {
  border-color: #d7e0ea;
  color: #4d5d72;
  background: linear-gradient(180deg, #ffffff 0%, #f3f7fb 100%);
  box-shadow: 0 4px 10px rgba(42, 58, 79, 0.12);
}

.column-selector-action-btn-light:hover {
  border-color: #c6d2e2;
  color: #34495e;
  background: linear-gradient(180deg, #fdfefe 0%, #eef3f8 100%);
}

@media (max-width: 576px) {
  .datatable-toolbar {
    justify-content: flex-end;
    flex-wrap: nowrap;
    gap: 0.3rem;
    margin-bottom: 0.2rem;
    transform: none;
    overflow: visible;
  }

  .page-size-box {
    width: auto;
    flex: 0 0 auto;
  }

  .column-selector {
    width: auto;
    flex: 0 0 auto;
  }

  .column-selector-toggle {
    width: auto;
    min-width: 112px;
  }

  .column-selector-menu {
    width: 280px;
    min-width: 280px;
    max-width: 92vw;
    right: 0;
  }
}
</style>
